module.exports = require('./createLocalStorageAuthableStore')
